"use client";

import React from "react";
import { Loader } from "lucide-react";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Form, FormField, FormItem, FormControl, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
function SignupForm() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="p-4 text-center animate-in fade-in duration-500">
        <p className="text-[var(--color-green-accent)] font-serif text-lg">
          {successMessage}
        </p>
      </div>;
  }
  return <Form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-4 space-y-0 w-full max-w-md mx-auto">
      <FormField control={control} name="email" rules={{
      required: "Email is required",
      pattern: {
        value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
        message: "Please enter a valid email address"
      }
    }} render={({
      field
    }) => <FormItem className="flex-1 space-y-0">
            <FormControl>
              <Input type="email" placeholder="Your email address" className="h-12 px-4 font-default bg-background border-border focus-visible:ring-[var(--color-green-accent)]/50" {...field} />
            </FormControl>
            <div className="absolute mt-1">
              <FormMessage className="font-serif text-xs" />
            </div>
          </FormItem>} />

      <Button type="submit" disabled={isSubmitting} className="h-12 px-8 font-serif text-base bg-[var(--color-green-accent)] hover:bg-[var(--color-green-accent)]/90 text-white border-none shadow-sm transition-all">
        {isSubmitting ? <>
            <Loader className="animate-spin mr-2 size-4" />
            Subscribing...
          </> : "Subscribe"}
      </Button>

      {submitError && <div className="absolute -bottom-8 left-0 right-0 text-center">
          <p className="text-destructive font-serif text-sm">{submitError}</p>
        </div>}
    </Form>;
}
export default function EmailSignupSection() {
  return <section id="email-signup-section" className="bg-background py-24 px-6">
      <div className="max-w-4xl mx-auto">
        <div className="bg-secondary border border-border shadow-sm rounded-2xl p-10 md:p-16 flex flex-col items-center justify-center text-center relative overflow-hidden">
          {}
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-[var(--color-green-accent)]/30 to-transparent opacity-50" />
          
          <h2 className="font-default text-2xl md:text-3xl lg:text-4xl font-semibold text-foreground mb-10 tracking-tight max-w-2xl">
            Get founder insights + wellness drops first
          </h2>

          <div className="w-full relative">
            <FormProvider formId="email-signup-minimal" sectionName="Email Signup Section" defaultValues={{
            email: ""
          }} submitText="Subscribe" successMessage="Thank you! You're on the list.">
              <SignupForm />
            </FormProvider>
          </div>
        </div>
      </div>
    </section>;
}